export default __webpack_public_path__ + "static/media/exp.57577249.svg";